import { mkdir } from 'node:fs/promises';
import { resolve } from 'node:path';
import { homedir } from 'node:os';
import { getTestOverrides } from '@wix/cli-test-overrides';

export function getDataDirPath() {
  return getTestOverrides().dataDir ?? resolve(homedir(), '.wix');
}

export async function ensureDataDirExists() {
  await mkdir(getDataDirPath(), { recursive: true });
}
